import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ExtendedInputComponent } from './extended-input/extended-input.component';
import { BooleanPipe } from './pipes/boolean.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { LocalCurrencyPipe } from './pipes/local-currency.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { NewlineToBrPipe } from './pipes/newline-to-br.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { PropertiesPipe } from './pipes/properties.pipe';

import { SanitizePipe } from './pipes/sanitize.pipe';
import { SkipPipe } from './pipes/skip.pipe';
import { TakePipe } from './pipes/take.pipe';

import { ValidationMessagesPipe } from './pipes/validation-messages.pipe';
import { QuestionableBooleanPipe } from './pipes/questionable-boolean.pipe';
import { FocusNextDirective } from './directives/focus-next.directive';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
//import { LoadingDirective } from './directives/loading.directive';
import { PhoneDirective } from './directives/phone.directive';
import { SearchResultComponent } from './search-result/search-result.component';
import { FavoriteListingComponent } from './favorite-listing/favorite-listing.component';
import { RatingDisplayComponent } from './rating-display/rating-display.component';
import { MobileContainerComponent } from './mobile-container/mobile-container.component';

import { ZeroAreEmptyPipe } from './pipes/zero-are-empty.pipe';
import { EmptyNAPipe } from './pipes/empty-na.pipe';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { SearchBoxComponent } from './search-box/search-box.component';
import { NewlineToParagraphPipe } from './pipes/newline-to-paragraph.pipe';
import { LexicalVariablePipe } from './pipes/lexical-variable.pipe';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TitleTaglineComponent } from './title-tagline/title-tagline.component';
import { ViewCountComponent } from './view-count/view-count.component';
import { ImageWithCaptionComponent } from '@app/shared2-components/image-with-caption/image-with-caption.component';
import { TimeSpanDisplayComponent } from './time-span-display/time-span-display.component';
import { TimeInputComponent } from './time-input/time-input.component';
import { BookingGridComponent } from './booking-grid/booking-grid.component';
import { AvailableTodayBadgeComponent } from './available-today-badge/available-today-badge.component';
import { ParticipantCountComponent } from './participant-count/participant-count.component';
import { BookingIdLabelComponent } from './booking-id-label/booking-id-label.component';
import { TextArrivalInstructionButtonComponent } from './text-arrival-instruction-button/text-arrival-instruction-button.component';

import { FieldNoteComponent } from './field-note/field-note.component';
import { CollectEmailComponent } from './collect-email/collect-email.component';
import { DefaultAvailabilitySummaryComponent } from './default-availability-summary/default-availability-summary.component';
import { BookingTypeIconComponent } from './booking-type-icon/booking-type-icon.component';
import { CancelReasonSelectComponent } from './cancel-reason-select/cancel-reason-select.component';
import { OAImageComponent } from './oaimage/oaimage.component';
import { DayOfWeekPickerComponent } from './day-of-week-picker/day-of-week-picker.component';

import { LocalDatePipe } from './pipes/local-date.pipe';
import { CommonComponentsModule } from '@app/common-components/common-components.module';
import { IconDirective } from './directives/icon.directive';
import { ContactHelpComponent } from './contact-help/contact-help.component';
/**
 * Shared Module For the entire application
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgbPopoverModule,
        CommonComponentsModule,
        NgbCarouselModule,
        ExtendedInputComponent,
        BooleanPipe,
        FilterPipe,
        LocalCurrencyPipe,
        DateFormatPipe,
        NewlineToBrPipe,
        PhoneNumberPipe,
        PropertiesPipe,
        SanitizePipe,
        SkipPipe,
        TakePipe,
        ValidationMessagesPipe,
        QuestionableBooleanPipe,
        FocusNextDirective,
        //LoadingDirective,
        PhoneDirective,
        InfiniteScrollDirective,
        FavoriteListingComponent,
        RatingDisplayComponent,
        SearchResultComponent,
        MobileContainerComponent,
        ZeroAreEmptyPipe,
        EmptyNAPipe,
        SlugifyPipe,
        SearchBoxComponent,
        NewlineToParagraphPipe,
        LexicalVariablePipe,
        TitleTaglineComponent,
        ViewCountComponent,
        ImageWithCaptionComponent,
        TimeSpanDisplayComponent,
        TimeInputComponent,
        BookingGridComponent,
        AvailableTodayBadgeComponent,
        ParticipantCountComponent,
        BookingIdLabelComponent,
        TextArrivalInstructionButtonComponent,
        FieldNoteComponent,
        CollectEmailComponent,
        DefaultAvailabilitySummaryComponent,
        BookingTypeIconComponent,
        CancelReasonSelectComponent,
        OAImageComponent,
        DayOfWeekPickerComponent,
        LocalDatePipe,
        IconDirective,
        ContactHelpComponent
    ],
    exports: [
        ReactiveFormsModule,
        ExtendedInputComponent,
        BooleanPipe,
        ZeroAreEmptyPipe,
        FilterPipe,
        LocalCurrencyPipe,
        DateFormatPipe,
        NewlineToBrPipe,
        NewlineToParagraphPipe,
        PhoneNumberPipe,
        PropertiesPipe,
        SanitizePipe,
        SkipPipe,
        TakePipe,
        ValidationMessagesPipe,
        QuestionableBooleanPipe,
        FocusNextDirective,
        //LoadingDirective,
        PhoneDirective,
        FavoriteListingComponent,
        RatingDisplayComponent,
        SearchResultComponent,
        MobileContainerComponent,
        InfiniteScrollDirective,
        EmptyNAPipe,
        SlugifyPipe,
        SearchBoxComponent,
        LexicalVariablePipe,
        TitleTaglineComponent,
        ViewCountComponent,
        ImageWithCaptionComponent,
        TimeSpanDisplayComponent,
        TimeInputComponent,
        BookingGridComponent,
        AvailableTodayBadgeComponent,
        ParticipantCountComponent,
        BookingIdLabelComponent,
        TextArrivalInstructionButtonComponent,
        FieldNoteComponent,
        CollectEmailComponent,
        DefaultAvailabilitySummaryComponent,
        BookingTypeIconComponent,
        CancelReasonSelectComponent,
        OAImageComponent,
        DayOfWeekPickerComponent,
        LocalDatePipe,
        ContactHelpComponent,
    ],
    providers: [SlugifyPipe, NewlineToParagraphPipe, LexicalVariablePipe]
})
export class SharedComponentsModule {}
